import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RbacCrudService } from './rbac-crud.base';
import { Role } from '../../../component/DashboardScreens/components/rbac.models';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class RoleService extends RbacCrudService<Role> {
  protected endpoint = '/Role';

  constructor(http: HttpClient, ) {
    super(http);
  }

}
